// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vbt-autcomplete-list[data-v-7723d337]{padding-top:5px;position:absolute;max-height:350px;-ms-overflow-style:-ms-autohiding-scrollbar;overflow-y:auto;z-index:999}.vbt-autcomplete-list[data-v-7723d337] .vbt-matched-text{font-weight:700}", ""]);
// Exports
module.exports = exports;
